import graph from "./graph";
import schema from "./schema";
import uiSchema from "./uiSchema";

import { useState } from "react";
import { toast } from "react-toastify";
import { useMutation } from "@apollo/client";
import { Stack, Button } from "@mui/material";
import { fetchUser } from "toolkits/redux/auth";
import { isEmptyObject } from "helpers/formatObject";
import { useDispatch, useSelector } from "react-redux";

import {
  NewDialog,
  MuiFormBuilder,
  NewDialogTitle,
  NewDialogContent,
  NewDialogActions,
} from "components";

export default function LabService({ plan, refetch }) {
  const { id, lab_quantity, unit_quantity, doctor_quantity } = plan;
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const { userToken } = useSelector((state) => state.auth);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const onChange = ({ formData, errors }) => {
    setFormData(formData);
  };

  const [create, { loading }] = useMutation(graph.create.query, {});

  const onSubmit = async ({ formData }) => {
    try {
      const { data, errors } = await create({
        context: {
          serviceName: graph.create.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          plan_id: id,
          ...formData,
        },
      });
      if (!errors) {
        onClose();
        refetch();
        dispatch(fetchUser(userToken));
        if (!isEmptyObject(data)) {
          const { messages } = data[graph.create.name];
          messages.map((message) => toast.success(String(message)));
        }
      }
    } catch (error) {
      dispatch(fetchUser(userToken));
    }
  };

  return (
    <>
      <Button size="small" color="warning" variant="outlined" onClick={onOpen}>
        خرید
      </Button>
      <NewDialog open={open} onClose={onClose}>
        <NewDialogTitle title="خرید" onClose={onClose} />
        <NewDialogContent isPopup>
          <Stack p={1} flex={1} rowGap={1} bgcolor="background.paper">
            <MuiFormBuilder
              id="submit"
              showSubmit={false}
              liveValidate={false}
              schema={schema()}
              uiSchema={uiSchema()}
              formData={formData}
              onSubmit={onSubmit}
              onChange={onChange}
            />
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button
            autoFocus
            fullWidth
            size="large"
            type="submit"
            form="submit"
            variant="contained"
            disabled={loading}
          >
            خرید
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
